// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__GUEqi","tag":"styles_tag__27GNi"};